import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxTextAreaComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {
  TIPI_PROPRIETA_ARTICOLO_LIST,
  TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO,
  TIPO_PROPRIETA_ARTICOLO_DATA,
  TIPO_PROPRIETA_ARTICOLO_NUMERO,
  TIPO_PROPRIETA_ARTICOLO_SELMULTI,
} from 'src/app/consts/tipi-proprieta-articolo';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import {
  MovimentiMagazzino,
  PostMovimentiMagazzinoMatricola,
} from 'src/app/models/movimenti-magazzino';
import { CausaliMovmagService } from 'src/app/shared/services/causali-movmag.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { CausaliMovMag } from 'src/app/models/causali-movmag';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import moment from 'moment';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-popup-add-mov-magazzino',
  templateUrl: './popup-add-mov-magazzino.component.html',
  styleUrls: ['./popup-add-mov-magazzino.component.scss'],
  imports: [
    CommonModule,
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxTextAreaComponent,
    DxLookupComponent,
    DxNumberBoxComponent,
    DxValidatorComponent,
    DxDateBoxComponent,
    DxDataGridComponent,
    DxoLookupComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoTextsComponent,
    DxiValidationRuleComponent,
  ],
  standalone: true,
})
export class PopupAddMovMagazzinoComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private tipiArticoliService = inject(TipiArticoliService);
  private causaliService = inject(CausaliMovmagService);
  private articoliService = inject(ArticoliService);
  private movMagService = inject(MovimentiMagazzinoService);
  private articoliMatService = inject(ArticoliMatricolaService);

  @ViewChild('dataGridArticoliMatricola', { static: false }) dataGridArticoliMatricola: DxDataGridComponent;
  @Output() popupAddMovMagazzinoEventEmitter = new EventEmitter<MovimentiMagazzino>();

  readonly listTipiProps = TIPI_PROPRIETA_ARTICOLO_LIST;
  readonly TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO =
    TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO;
  readonly TIPO_PROPRIETA_ARTICOLO_NUMERO = TIPO_PROPRIETA_ARTICOLO_NUMERO;
  readonly TIPO_PROPRIETA_ARTICOLO_DATA = TIPO_PROPRIETA_ARTICOLO_DATA;
  readonly TIPO_PROPRIETA_ARTICOLO_SELMULTI = TIPO_PROPRIETA_ARTICOLO_SELMULTI;

  loadPanelVisible = false;
  nuovoMovimentoMag = new MovimentiMagazzino();

  listTipiArticoli: TipiArticoli[];
  listArticoli: any;
  listCausali: any;
  gestisciMatricola = false;
  listArticoliMatricola: any[];
  listPropsArtMatricola: any[];
  causaleInserimento: CausaliMovMag;

  listMatricoleDisponibili: any[];
  gestMatricole: boolean;
  dataMovimento: Date;

  constructor() {
    super();

    this.gestMatricole = this.isModVisible('Matricole');
    this.onSalvaClick = this.onSalvaClick.bind(this);
  }

  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    this.causaliService.getCausaleMovMagDefInsTemp().subscribe({
      next: (res) => {
        this.causaleInserimento = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify(
            'Errore caricamento causale inserimento default',
            'error',
            3000,
          );
        }
      },
    });
    this.causaliService.getListCausaliMovMagTemp().subscribe({
      next: (res) => {
        this.listCausali = {
          store: {
            type: 'array',
            data: res
              .filter((x) => x.visibilePerMovimentazione == true)
              .sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento causali', 'error', 3000);
        }
      },
    });

    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.filter(x => x.attivo == true),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      }
    });

    this.tipiArticoliService.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'error', 3000);
        }
      },
    });
  }

  onValueArticoloChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.prepareGestMatricola();
    }
  }

  onValueCausaleChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.prepareGestMatricola();
    }
  }

  onValueQtaChanged() {
    if (
      this.nuovoMovimentoMag.idCausale > 0 &&
      this.nuovoMovimentoMag.idArticolo > 0 &&
      this.nuovoMovimentoMag.qta > 0
    ) {
      this.prepareGestMatricola();
    }
  }

  prepareGestMatricola() {
    const articolo = this.listArticoli.store.data.find(
      (a) => a.id == this.nuovoMovimentoMag.idArticolo,
    );
    const tipologia = this.listTipiArticoli.find(
      (t) => t.id == articolo.idTipo,
    );
    if (tipologia.usaMatricola && this.gestMatricole) {
      this.gestisciMatricola = true;
      if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
        this.listPropsArtMatricola = JSON.parse(tipologia.propJSON);
        if (!this.listArticoliMatricola) {
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            const newArtMatricola = {
              index: _i + 1,
              matricola: '',
              idArticolo: this.nuovoMovimentoMag.idArticolo,
              dismesso: false,
              props: [],
              idTipologia: articolo.idTipo,
            };
            this.listArticoliMatricola.push(newArtMatricola);
          }
        } else {
          const temp = this.listArticoliMatricola;
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            if (temp[_i]) {
              const newArtMatricola = {
                index: _i + 1,
                matricola: temp[_i].matricola,
                idArticolo: this.nuovoMovimentoMag.idArticolo,
                dismesso: false,
                props:
                  temp[_i].idTipologia == articolo.idTipo ? temp[_i].props : [],
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            } else {
              const newArtMatricola = {
                index: _i + 1,
                matricola: '',
                idArticolo: this.nuovoMovimentoMag.idArticolo,
                dismesso: false,
                props: [],
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            }
          }
        }
      } else {
        if (
          !this.listMatricoleDisponibili ||
          this.listMatricoleDisponibili.length == 0 ||
          this.listMatricoleDisponibili[0].idArticolo != articolo.id
        ) {
          this.articoliMatService.listDisponibili(articolo.id).subscribe({
            next: (res) => {
              this.listMatricoleDisponibili = res;
            },
            error: (error) => {
              if (error?.status == 500 && error?.error?.title) {
                notify(error?.error?.title, 'warning');
              } else {
                notify(
                  'Errore caricamento matricole disponibili',
                  'error',
                  3000,
                );
              }
            },
          });
        }
        if (!this.listArticoliMatricola) {
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            const newArtMatricola = {
              index: _i + 1,
              id: 0,
              idTipologia: articolo.idTipo,
            };
            this.listArticoliMatricola.push(newArtMatricola);
          }
        } else {
          const temp = this.listArticoliMatricola;
          this.listArticoliMatricola = [];
          for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
            if (temp[_i]) {
              const newArtMatricola = {
                index: _i + 1,
                id: temp[_i].idTipologia == articolo.idTipo ? temp[_i].id : 0,
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            } else {
              const newArtMatricola = {
                index: _i + 1,
                id: 0,
                idTipologia: articolo.idTipo,
              };
              this.listArticoliMatricola.push(newArtMatricola);
            }
          }
        }
      }
    } else {
      this.gestisciMatricola = false;
    }
  }

  parseProps(jsonProps) {
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      const props = JSON.parse(jsonProps);
      props.forEach((element) => {
        element.valore = null;
      });
      return props;
    }
    return null;
  }

  getDataType(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return 'number';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'date';
    }
    return 'string';
  }

  getDataFormat(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return '0';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'dd/MM/yyyy';
    }
    return '';
  }

  onEsciClick() {
    this.popupAddMovMagazzinoEventEmitter.emit(null);
  }

  onSalvaClick(e) {
    const result = e.validationGroup.validate();
    if (!result.isValid) {
      return;
    }
    this.nuovoMovimentoMag.data = moment(this.dataMovimento).utc(true).toDate();
    if (this.gestisciMatricola) {
      this.dataGridArticoliMatricola.instance.saveEditData();
      const checkResult = this.checkDatiMatricola();
      if (checkResult) {
        const obj = new PostMovimentiMagazzinoMatricola();
        obj.movimentoMagazzino = this.nuovoMovimentoMag;
        obj.listArticoliMatricola = this.buildPostListObj();
        this.loadPanelVisible = true;
        this.movMagService.postMovMagMatricole(obj).subscribe({
          next: (res) => {
            this.loadPanelVisible = false;
            notify(
              'Movimento magazzino per articoli matricola inseriti correttamente',
              'success',
              3000,
            );
            this.popupAddMovMagazzinoEventEmitter.emit(res);
          },
          error: (error) => {
            this.loadPanelVisible = false;
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore salvataggio dati movimento', 'error', 3000);
            }
          },
        });
      }
    } else {
      this.loadPanelVisible = true;
      this.movMagService.post(this.nuovoMovimentoMag).subscribe({
        next: (res) => {
          this.loadPanelVisible = false;
          notify('Movimento magazzino inserito correttamente', 'success', 3000);
          this.popupAddMovMagazzinoEventEmitter.emit(res);
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore salvataggio dati movimento', 'error', 3000);
          }
        },
      });
    }
  }

  checkDatiMatricola() {
    const resDuplicati = this.checkDuplicatiMatricola();
    const resDatiObbligatori = this.checkDatiObbligatori();
    return resDuplicati && resDatiObbligatori;
  }

  checkDuplicatiMatricola() {
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      const listMatricole = this.listArticoliMatricola.map(function (item) {
        return item.matricola.trim();
      });
      const findDuplicates = listMatricole.some(
        (item, index) => listMatricole.indexOf(item) !== index,
      );
      if (findDuplicates) {
        this.notificaMess(
          'Non è consentito inserire 2 o più matricole uguali',
          'warning',
        );
        return false;
      }
      return true;
    } else {
      const listIdsArtMat = this.listArticoliMatricola.map(function (item) {
        return item.id;
      });
      const findDuplicates = listIdsArtMat.some(
        (item, index) => listIdsArtMat.indexOf(item) !== index,
      );
      if (findDuplicates) {
        this.notificaMess(
          'Non è consentito selezionare 2 articoli matricola uguali',
          'warning',
        );
        return false;
      }
      return true;
    }
  }

  checkDatiObbligatori() {
    let ret = true;
    if (this.nuovoMovimentoMag.idCausale == this.causaleInserimento.id) {
      for (let _i = 0; _i < this.nuovoMovimentoMag.qta; _i++) {
        const tempArtMat = this.listArticoliMatricola[_i];
        if (!tempArtMat.matricola) {
          this.notificaMess(
            'Inserire matricola per articolo ' + (_i + 1),
            'warning',
          );
          ret = false;
        }
        this.listPropsArtMatricola?.forEach((element) => {
          if (element.obbligatorio && !tempArtMat.props[element.nome]) {
            this.notificaMess(
              'Proprieta ' +
                element.nome +
                ' obbligatoria per articolo ' +
                (_i + 1),
              'warning',
            );
            ret = false;
          }
        });
      }
    }
    return ret;
  }

  convertDataMapped(currentProps, propsTipo) {
    const origData = [];
    propsTipo?.forEach((element) => {
      const newData = {
        nome: element.nome,
        tipo: element.tipo,
        obbligatorio: element.obbligatorio,
        controlloNotifica: element.controlloNotifica,
        selMultiplaDati: element.selMultiplaDati,
        valore: currentProps[element.nome],
      };
      origData.push(newData);
    });
    return JSON.stringify(origData);
  }

  buildPostListObj() {
    const ret: ArticoliMatricola[] = [];
    this.listArticoliMatricola.forEach((element) => {
      let tempArtMat = new ArticoliMatricola();
      if (element.id > 0) {
        tempArtMat = this.listMatricoleDisponibili.find(
          (m) => m.id == element.id,
        );
      } else {
        tempArtMat.idArticolo = element.idArticolo;
        tempArtMat.matricola = element.matricola;
        tempArtMat.propJson = this.convertDataMapped(
          element.props,
          this.listPropsArtMatricola,
        );
        tempArtMat.dismesso = element.dismesso;
      }
      ret.push(tempArtMat);
    });
    return ret;
  }

  notificaMess(strMess: string, typeMess: string) {
    const position: any = 'bottom center';
    const direction: any = 'up-stack';

    notify(
      {
        message: strMess,
        height: 45,
        width: 350,
        minWidth: 150,
        type: typeMess,
        displayTime: 3000,
        animation: {
          show: {
            type: 'fade',
            duration: 400,
            from: 0,
            to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      },
      { position, direction },
    );
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.tipo.descrizione +
      ' - ' +
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }
}
